import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/site/Hero";
import TrustMarquee from "@/components/site/TrustMarquee";
import Carriers from "@/components/site/Carriers";
import Services from "@/components/site/Services";
import Calculator from "@/components/site/Calculator";
import Solutions from "@/components/site/Solutions";
import Manifesto from "@/components/site/Manifesto";
import Founder from "@/components/site/Founder";
import Booking from "@/components/site/Booking";
import FAQ from "@/components/site/FAQ";
import BlogTeaser from "@/components/site/BlogTeaser";
import Contact from "@/components/site/Contact";

export default function Home() {
  const location = useLocation();
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (id) {
      const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <TrustMarquee />
      <Carriers />
      <Services />
      <Calculator />
      <Solutions />
      <Manifesto />
      <Founder />
      <Booking />
      <FAQ />
      <BlogTeaser />
      <Contact />
    </>
  );
}
